// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const UserPropertiesConstants = Marty.createConstants([
  'FETCH_USER_PROPERTIES',
  'UPDATE_USER_PROPERTIES'
])

UserPropertiesConstants.ACKED_USER_IMPORT_TOOL = 'ackedUserImportTool'

export default UserPropertiesConstants



// WEBPACK FOOTER //
// ./src/scripts/constants/UserPropertiesConstants.js